const Leaderboard = ({ scores }) => {
    return (
        <div style={{ textAlign: 'center' }}>
            <h2 style={{ fontFamily: 'Dirty Brush', fontSize: '40px' }}>Top Chops</h2>
            <ol>
  {scores.map((entry, index) => (
    <li key={index}>
      <span className="name-score">
        {entry.name}: <span className="number-display">
          {parseFloat(entry.score).toFixed(2)}
        </span>
      </span>
    </li>
  ))}
</ol>

        </div>
    );
};

export default Leaderboard;
